<template>
  <el-dialog :visible.sync="isVisible" :model="true" :lockScroll="true" :custom-class="'gallery-dialog'">
    <span>
      <div class="controls-wrapper" v-if="images.length > 1">
        <div class="controls">
          <span class="left" @click="setPrevIndex()">
            <i class="fa fa-angle-left"></i>
          </span>
          <span class="right" @click="setNextIndex()">
            <i class="fa fa-angle-right"></i>
          </span>
        </div>
      </div>
      <div class="image-wrapper">
        <img :src="images[selectedIndex]">
      </div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Gallery',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      required: true,
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('setVisible', value);
      },
    },
  },
  methods: {
    setNextIndex() {
      let nextIndex = this.selectedIndex + 1;
      if (nextIndex >= this.images.length) {
        nextIndex = 0;
      }
      this.selectedIndex = nextIndex;
    },

    setPrevIndex() {
      let prevIndex = this.selectedIndex - 1;
      if (prevIndex < 0) {
        prevIndex = this.images.length - 1;
      }
      this.selectedIndex = prevIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
  .image-wrapper {
    width: 100%;
    text-align: center;

    img {
      max-width: 100%
    }
  }


  .controls {
    font-size: 60px;
    position: absolute;
    height: calc(100% - 101px);
    width: 100%;
    margin-left: -20px;

    .left, .right {
      color: #fff;
      position: absolute;
      height: 100%;
      width: 200px;
      cursor: pointer;

      i {
        position: relative;
        top: calc(50% - 50px);
        text-shadow: 1px 1px 2px #000;
      }
    }

    .left {
      margin-left: 8px;
    }

    .right {
      right: 0;
      text-align: right;
      margin-right: 8px;
    }
  }
</style>

<style lang="scss">
  .gallery-dialog {
    background: #000;
  }
</style>



// WEBPACK FOOTER //
// Gallery.vue?1e238a3e